import React from 'react';

const Page404 =  (props) => (
  <div className="container">
    Page404
  </div>
)

export default Page404;